/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flagship_Onboarding_Progress_LabelInputs */

const en_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding progress`)
};

const de_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt der Einrichtung`)
};

const pt_br2_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso da configuração`)
};

const tr_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç ilerlemesi`)
};

const zh_cn2_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开户进度`)
};

const zh_hk2_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開戶設定進度`)
};

const ko_kr2_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온보딩 진행률`)
};

const ru_ru2_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прогресс настройки`)
};

const es_419_flagship_onboarding_progress_label = /** @type {(inputs: Flagship_Onboarding_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso del onboarding`)
};

/**
* | output |
* | --- |
* | "Onboarding progress" |
*
* @param {Flagship_Onboarding_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const flagship_onboarding_progress_label = /** @type {((inputs?: Flagship_Onboarding_Progress_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flagship_Onboarding_Progress_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flagship_onboarding_progress_label(inputs)
	if (locale === "de") return de_flagship_onboarding_progress_label(inputs)
	if (locale === "pt-BR") return pt_br2_flagship_onboarding_progress_label(inputs)
	if (locale === "tr") return tr_flagship_onboarding_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_flagship_onboarding_progress_label(inputs)
	if (locale === "zh-HK") return zh_hk2_flagship_onboarding_progress_label(inputs)
	if (locale === "ko-KR") return ko_kr2_flagship_onboarding_progress_label(inputs)
	if (locale === "ru-RU") return ru_ru2_flagship_onboarding_progress_label(inputs)
	return es_419_flagship_onboarding_progress_label(inputs)
});